"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactCropper = _interopRequireDefault(require("react-cropper"));

require("./ImageCropper.scss");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const ImageCropperBase = ({
  className,
  imageUrl,
  imageCropdata,
  options,
  aspectRatio,
  onChange
}) => {
  const classes = useStyles();
  const cropperRef = (0, _react.useRef)(null);

  if (!imageUrl) {
    return _react.default.createElement("p", null, "No imageUrl for cropper");
  }

  const onReady = () => {
    const image = cropperRef.current.getImageData();
    const imageWidth = image && image.naturalWidth;
    const imageHeight = image && image.naturalHeight;
    const x = imageCropdata && imageCropdata.x * imageWidth / 100 || 0;
    const y = imageCropdata && imageCropdata.y * imageHeight / 100 || 0;
    const width = imageCropdata && imageCropdata.width * imageWidth / 100 || imageWidth;
    const height = imageCropdata && imageCropdata.height * imageHeight / 100 || imageHeight;
    cropperRef.current.setData(_extends({}, imageCropdata, {
      x: x,
      y: y,
      width: width,
      height: height
    })); //        cropperRef.current.setData(imageCropdata);
  };

  const onCrop = () => {
    const data = cropperRef.current.getData();
    const image = cropperRef.current.getImageData();
    const imageWidth = image && image.naturalWidth;
    const imageHeight = image && image.naturalHeight;
    const x = data.x / imageWidth * 100;
    const y = data.y / imageHeight * 100;
    const width = data.width / imageWidth * 100;
    const height = data.height / imageHeight * 100;

    const newFormData = _extends({}, data, {
      x: x,
      y: y,
      width: width,
      height: height
    });

    onChange && onChange(newFormData);
  };

  options = _extends({}, options, {
    aspectRatio: aspectRatio
  });
  return _react.default.createElement(_reactCropper.default, _extends({
    className: className || classes.root,
    ref: cropperRef,
    src: imageUrl
  }, options, {
    ready: onReady.bind(void 0),
    crop: onCrop.bind(void 0)
  }));
};

ImageCropperBase.defaultProps = {
  imageUrl: undefined,
  options: {
    viewMode: 0,
    dragMode: "crop",
    initialAspectRatio: undefined,
    aspectRatio: undefined,
    responsive: true,
    restore: true,
    checkCrossOrigin: false,
    checkOrientation: true,
    modal: true,
    guides: true,
    center: true,
    highlight: true,
    background: true,
    autoCrop: true,
    autoCropArea: 1,
    movable: true,
    rotatable: true,
    scalable: true,
    zoomable: true,
    zoomOnTouch: true,
    zoomOnWheel: true,
    wheelZoomRatio: 0.1,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: true
  },
  imageCropdata: {
    "x": undefined,
    "y": undefined,
    "width": undefined,
    "height": undefined,
    "rotate": undefined
  }
};
var _default = ImageCropperBase;
exports.default = _default;
module.exports = exports.default;